<template>
  <div style="width: 40%;height: 100px;text-align: center;" :style="{
      '--radio-button-color': $store.getters.getRadioButtonColor,
      '--star-svg-height': `${starHeight}px`
      }">
    <ul class="rating-card__list">
      <li class="rating-card__list__item" v-bind:class="{'-select': model.crowded}"
          v-for="(model, index) in question.answers"
          v-on:click="selectStar(model, index)" v-bind:key="index">
        <label>

<svg v-bind:class="{'bounce': model.bounced}" class="star-ico"  xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
	 viewBox="0 0 576 512" style="enable-background:new 0 0 576 512;" xml:space="preserve">
<path d="M432.8,184.6c0-29.5-14.3-55.6-36.3-71.9c4.6-9.5,7.2-20.2,7.2-31.4c0-39.9-32.4-72.3-72.3-72.3
	c-38.9,0-70.6,30.7-72.2,69.1c-4.9-1.1-10-1.7-15.3-1.7c-38.6,0-69.9,31.3-69.9,69.9c0,17.5,6.4,33.5,17.1,45.7
	c0.1,5.7,1,11.3,2.5,16.8c0.6,2-1.6,4.5-2.4,6.5c-0.9,2.2,0.1,4.8,1.8,6.4c1.8,1.6,4.1,2.3,6.4,2.8c2.4,0.5,4.9,0.9,7.4,1.3
	l-42.8,271.6c-1.1,7,8.1,10.5,12,4.6l145.4-221.7c0.2,0.4,0.5,0.7,0.7,1.1c2.8,4,6.5,7.8,11.3,8.7c4.8,0.8,10.6-3.3,10.2-8.1
	c6.5-2.3,12.6-5.7,18.2-9.9C402.3,263.7,432.8,227.7,432.8,184.6z"/>
</svg>


          <div style="font-weight:200">{{ model.title }}&nbsp;&nbsp;</div>
        </label>
      </li>
    </ul>


    <label v-for="model in question.answers" v-bind:key="model.uid">
      <input style="display:none;" type="radio"
             v-bind:id="'star'+ model.uid"
             v-on:click="setRadio(model.uid)"
             :value="model.uid"
             :name="question.uid"
             :checked="model.selected"
      />
    </label>

    <transition name="fade">
      <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
    </transition>
    <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
  </div>
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';
import Star from 'vue-rate-it/glyphs/star';


export default {
  name: 'pepper',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false,
      radioButtonCheckedPath: false,
      radioButtonUncheckedPath: false,
      thumbsUp: '',
      starHeight: 40,
      stars: [{
        value: 1,
        text: '',
        gradientFrom: '#FC8885',
        gradientTo: '#FB7C7F',
        selected: false,
      },
        {
          value: 2,
          text: '',
          gradientFrom: '#FB7A7E',
          gradientTo: '#F96A74',
          selected: false,
        },
        {
          value: 4,
          text: '',
          gradientFrom: '#F8636F',
          gradientTo: '#F75062',
          selected: false,
        },
        {
          value: 5,
          text: '',
          gradientFrom: '#F75165',
          gradientTo: '#F6415A',
          selected: false,
        }
      ]
    }
  },
  created() {
    // register the icon
    this.star = Star
  },
  mounted() {
    this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
    this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
  },
  methods: {
    setRadio: function (uid) {
      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;
          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    },
    onRatingSelected(e) {
      this.setRadio(e);
    },
    resetStars() {
      this.question.answers.forEach(model => model.crowded = false)
    },
    selectStar(model, index) {
      console.log('select');
      this.resetStars()
      let i = 0;
      this.setRadio(model.uid);
      const f = () => {
        if (i <= index) {
          this.question.answers[i].crowded = true;
          i++;
          setTimeout(f, 100)
        }
        model.bounced = true;
      }
      model.bounced = false;
      setTimeout(f, 100)
    },
  },
  components: {
    Comment
  }
}
</script>

<style>

:root {
  --star-svg-height: '100px'
}

@keyframes bounce {
  0% {
    width: 42px;
    height: 66px;
  }
  25% {
    width: 44px;
    height: 68px;
  }
  50% {
    width: 46px;
    height: 69px;
  }
  100% {
    width: 48px;
    height: 70px;
  }
}

.bounce {
  animation-name: bounce;
  animation-duration: 0.2s;
}
</style>
<style lang="scss">
.rating-card__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  flex-basis: auto;

  &__item {
    flex-basis: 25%;
    flex-grow: 1;
    font-size: 12px;
    padding-left: 10px;

    .-checked & {
      font-weight: 200;
    }

    input {
      display: none;
    }

    input:checked + label {
      font-weight: 500;
    }

    svg {
      width: var(--star-svg-height);
      height: 54px;

      &:hover {
        cursor: pointer;
      }

      path {
        fill: #e6e7ea;
      }
    }

    &.-select {
      svg {
        path {
          fill: var(--radio-button-color)
        }
      }
    }
  }
}
</style>
